<template>
<section class="portfolio" id="portfolio">
    <div class="title-container">
          <h2 class="title">Przykładowe projekty</h2>
      </div>
        <div class="usage">
          <p>wybierając <img src="https://i.imgur.com/Yz9Siqn.png" class="loupe" alt=""> na projekcie możesz  zobaczyć więcej informacji o nim</p>
        </div>
      <div class="projects-container" v-show="!tablet && !mobile">
          <div class="single-project hidden">
              <div class="img">
            <img src="https://i.imgur.com/fyhtNJ1.png" alt="">
            </div>
            <div class="info">
              <img src="https://i.imgur.com/Yz9Siqn.png" class="more-info" @click="moveToPogrzeby" alt="">
                <ProjectInfo 
                :title="'Mazowiecki Dom Pogrzebowy'"
                :desc="'Praca na podstawie makiety graficznej, tworzenie wyglądu strony głównej.'"
                :usedTech="'Głównie wykorzystane technologie:'"
                />
                <div class="tech-icons">
                  <TechIcon 
                    :tech="'https://i.imgur.com/Hxezg04.png'"
                  />
                  <TechIcon 
                    :tech="'https://i.imgur.com/0TZCvMJ.png'"
                  />
                  <TechIcon 
                    :tech="'https://i.imgur.com/Yg7MzAm.png'"
                  />
                </div>
                <p class="made-for">Wykonano dla: Sysmo</p>
            </div>
          </div>
          <div class="single-project hidden">
              <div class="img">
            <img src="https://i.imgur.com/ANs7Eka.png" alt="">
            </div>
            <div class="info">
                <img src="https://i.imgur.com/Yz9Siqn.png" class="more-info" @click="moveToDaga" alt="">
                <ProjectInfo 
                :title="'Daga Joga'"
                :desc="'Praca na podstawie makiety graficznej, tworzenie wyglądu i mechanik działania wielu podstron.'"
                  :usedTech="'Głównie wykorzystane technologie:'"
                />
                <div class="tech-icons">
                  <TechIcon 
                    :tech="'https://i.imgur.com/Hxezg04.png'"
                  />
                  <TechIcon 
                    :tech="'https://i.imgur.com/0TZCvMJ.png'"
                  />
                  <TechIcon 
                    :tech="'https://i.imgur.com/Yg7MzAm.png'"
                  />
                </div>
                <p class="made-for">Wykonano dla: Sysmo</p>
          </div>
          </div>
          <div class="single-project hidden">
              <div class="img">
            <img src="https://i.imgur.com/OfHct0F.png" alt="">
            </div>
            <div class="info">
                <img src="https://i.imgur.com/Yz9Siqn.png" class="more-info" @click="moveToDziennik" alt="">
                <ProjectInfo 
                :title="'Dziennik Wędkarza'"
                :desc="'Bardzo prosty Landing Page bez żadnych podstron.'"
                :usedTech="'Głównie wykorzystane technologie:'"
                />
                <div class="tech-icons">
                  <TechIcon 
                    :tech="'https://i.imgur.com/Hxezg04.png'"
                  />
                  <TechIcon 
                    :tech="'https://i.imgur.com/0TZCvMJ.png'"
                  />
                  <TechIcon 
                    :tech="'https://i.imgur.com/IPGC8fZ.png'"
                  />
                </div>
                <p class="made-for">Wykonano dla: Sysmo</p>
            </div>
          </div>
          <div class="single-project hidden reverse">
              <div class="img">
            <img src="https://i.imgur.com/KYe3qS6.png" alt="">
            </div>
            <div class="info">
                <ProjectInfo 
                :title="'SkiInstruktor'"
                :desc="'Stworzenie strony głównej oraz kilku podstron z projektu graficznego.'"
                :usedTech="'Głównie wykorzystane technologie:'"
                />
                <div class="tech-icons">
                  <TechIcon 
                    :tech="'https://i.imgur.com/Hxezg04.png'"
                  />
                  <TechIcon 
                    :tech="'https://i.imgur.com/0TZCvMJ.png'"
                  />
                  <TechIcon 
                    :tech="'https://i.imgur.com/ibnrgcO.png'"
                  />
                </div>
                <p class="made-for">Wykonano dla: Sysmo</p>
            </div>
          </div>
          <div class="single-project hidden reverse">
              <div class="img">
            <img src="https://i.imgur.com/ojoEWm1.png" alt="">
            </div>
            <div class="info">
                <img src="https://i.imgur.com/Yz9Siqn.png" class="more-info" @click="moveToAutolivio" alt="">
                    <ProjectInfo 
                :title="'Autolivio'"
                :desc="'Pierwszy większy samodzielny projekt (niekomercyjny), który kiedykolwiek zrobiłem w celu sprawdzenia się i usystematyzowania wiedzy.'"
                :usedTech="'Głównie wykorzystane technologie:'"
                />
                <div class="tech-icons">
                  <TechIcon 
                    :tech="'https://i.imgur.com/Hxezg04.png'"
                  />
                  <TechIcon 
                    :tech="'https://i.imgur.com/x7j36Re.png'"
                  />
                  <TechIcon 
                    :tech="'https://i.imgur.com/IPGC8fZ.png'"
                  />
                </div>
            </div>
          </div>
          <div class="single-project hidden reverse">
              <div class="img">
            <img src="https://i.imgur.com/NTIdEMn.png" alt="">
            </div>
            <div class="info">
              <img src="https://i.imgur.com/Yz9Siqn.png" class="more-info" @click="moveToProdeck" alt="">
                 <ProjectInfo 
                :title="'ProDeck'"
                :desc="'Projekt tworzony na podstawie makiety graficznej.'"
                :usedTech="'Głównie wykorzystane technologie:'"
                />
                <div class="tech-icons">
                  <TechIcon 
                    :tech="'https://i.imgur.com/Hxezg04.png'"
                  />
                  <TechIcon 
                    :tech="'https://i.imgur.com/0TZCvMJ.png'"
                  />
                </div>
                <p class="made-for">Wykonano dla: Sysmo</p>
            </div>
          </div>
      </div>

      <!-- Tablet -->
      <!-- Tablet -->
      <!-- Tablet -->

        <div class="projects-container medium-view" v-show="tablet">
          <div class="single-project hidden">
              <div class="img">
            <img src="https://i.imgur.com/fyhtNJ1.png" alt="">
            </div>
            <div class="info">
                <img src="https://i.imgur.com/Yz9Siqn.png" class="more-info" @click="moveToPogrzeby" alt="">
                <ProjectInfo 
                :title="'Mazowiecki Dom Pogrzebowy'"
                :desc="'Praca na podstawie makiety graficznej, tworzenie wyglądu strony głównej.'"
                :usedTech="'Głównie wykorzystane technologie:'"
                />
                <div class="tech-icons">
                  <TechIcon 
                    :tech="'https://i.imgur.com/Hxezg04.png'"
                  />
                  <TechIcon 
                    :tech="'https://i.imgur.com/0TZCvMJ.png'"
                  />
                  <TechIcon 
                    :tech="'https://i.imgur.com/Yg7MzAm.png'"
                  />
                </div>
                <p class="made-for">Wykonano dla Sysmo</p>
            </div>
          </div>
          <div class="single-project hidden">
             <div class="img">
            <img src="https://i.imgur.com/ANs7Eka.png" alt="">
            </div>
            <div class="info">
                <img src="https://i.imgur.com/Yz9Siqn.png" class="more-info" @click="moveToDaga" alt="">
                <ProjectInfo 
                :title="'Daga Joga'"
                :desc="'Praca na podstawie projektu graficznego, tworzenie wyglądu i mechanik wielu podstron.'"
                :usedTech="'Głównie wykorzystane technologie:'"
                />
                <div class="tech-icons">
                  <TechIcon 
                    :tech="'https://i.imgur.com/Hxezg04.png'"
                  />
                  <TechIcon 
                    :tech="'https://i.imgur.com/0TZCvMJ.png'"
                  />
                  <TechIcon 
                    :tech="'https://i.imgur.com/Yg7MzAm.png'"
                  />
                </div>
                <p class="made-for">Wykonano dla: Sysmo</p>
          </div>
          </div>
          <div class="single-project hidden reverse">
            <div class="img">
            <img src="https://i.imgur.com/OfHct0F.png" alt="">
            </div>
            <div class="info">
                <img src="https://i.imgur.com/Yz9Siqn.png" class="more-info" @click="moveToDziennik" alt="">
                <ProjectInfo 
                :title="'Dziennik Wędkarza'"
                :desc="'Bardzo prosty Landing Page bez żadnych podstron.'"
                :usedTech="'Głównie wykorzystane technologie:'"
                />
                <div class="tech-icons">
                  <TechIcon 
                    :tech="'https://i.imgur.com/Hxezg04.png'"
                  />
                  <TechIcon 
                    :tech="'https://i.imgur.com/0TZCvMJ.png'"
                  />
                  <TechIcon 
                    :tech="'https://i.imgur.com/IPGC8fZ.png'"
                  />
                </div>
                <p class="made-for">Wykonano dla: Sysmo</p>
            </div>
          </div>
          <div class="single-project hidden reverse">
           <div class="img">
            <img src="https://i.imgur.com/KYe3qS6.png" alt="">
            </div>
            <div class="info">
                <ProjectInfo 
                :title="'SkiInstruktor'"
                :desc="'Stworzenie strony głównej oraz kilku podstron z projektu graficznego.'"
                :usedTech="'Głównie wykorzystane technologie:'"
                />
                <div class="tech-icons">
                  <TechIcon 
                    :tech="'https://i.imgur.com/Hxezg04.png'"
                  />
                  <TechIcon 
                    :tech="'https://i.imgur.com/0TZCvMJ.png'"
                  />
                  <TechIcon 
                    :tech="'https://i.imgur.com/ibnrgcO.png'"
                  />
                </div>
                <p class="made-for">Wykonano dla: Sysmo</p>
            </div>
          </div>
          <div class="single-project hidden">
            <div class="img">
            <img src="https://i.imgur.com/ojoEWm1.png" alt="">
            </div>
            <div class="info">
                 <img src="https://i.imgur.com/Yz9Siqn.png" class="more-info" @click="moveToAutolivio" alt="">
                <ProjectInfo 
                :title="'Autolivio'"
                :desc="'Pierwszy większy samodzielny projekt (niekomercyjny), który zrobiłem w celu sprawdzenia się i usystematyzowania wiedzy.'"
                :usedTech="'Głównie wykorzystane technologie:'"
                />
                <div class="tech-icons">
                  <TechIcon 
                    :tech="'https://i.imgur.com/Hxezg04.png'"
                  />
                  <TechIcon 
                    :tech="'https://i.imgur.com/0TZCvMJ.png'"
                  />
                  <TechIcon 
                    :tech="'https://i.imgur.com/IPGC8fZ.png'"
                  />
                </div>
            </div>
          </div>
          <div class="single-project hidden">
          <div class="img">
            <img src="https://i.imgur.com/NTIdEMn.png" alt="">
            </div>
            <div class="info">
                <img src="https://i.imgur.com/Yz9Siqn.png" class="more-info" @click="moveToProdeck" alt="">
                 <ProjectInfo 
                :title="'ProDeck'"
                :desc="'Projekt tworzony na podstawie makiety graficznej.'"
                :usedTech="'Głównie wykorzystane technologie:'"
                />
                <div class="tech-icons">
                  <TechIcon 
                    :tech="'https://i.imgur.com/Hxezg04.png'"
                  />
                  <TechIcon 
                    :tech="'https://i.imgur.com/0TZCvMJ.png'"
                  />
                </div>
                <p class="made-for">Wykonano dla: Sysmo</p>
            </div>
          </div>
      </div>

        <!-- Telefon -->
        <!-- Telefon -->
        <!-- Telefon -->

          <div class="projects-container small-view" v-show="mobile">
          <div class="single-project hidden">
            <div class="img">
            <img src="https://i.imgur.com/fyhtNJ1.png" alt="">
            </div>
            <div class="info">
                <img src="https://i.imgur.com/Yz9Siqn.png" class="more-info" @click="moveToPogrzeby" alt="">
                <ProjectInfo 
                :title="'Mazowiecki Dom Pogrzebowy'"
                :desc="'Praca na podstawie makiety graficznej, tworzenie wyglądu strony głównej.'"
                :usedTech="'Głównie wykorzystane technologie:'"
                />
                <div class="tech-icons">
                  <TechIcon 
                    :tech="'https://i.imgur.com/Hxezg04.png'"
                  />
                  <TechIcon 
                    :tech="'https://i.imgur.com/0TZCvMJ.png'"
                  />
                  <TechIcon 
                    :tech="'https://i.imgur.com/Yg7MzAm.png'"
                  />
                </div>
                <p class="made-for">Wykonano dla Sysmo</p>
            </div>
          </div>
          <div class="single-project hidden reverse">
              <div class="img">
            <img src="https://i.imgur.com/ANs7Eka.png" alt="">
            </div>
            <div class="info">
                <img src="https://i.imgur.com/Yz9Siqn.png" class="more-info" @click="moveToDaga" alt="">
                <ProjectInfo 
                :title="'Daga Joga'"
                :desc="'Tworzenie wyglądu i mechanik działania wielu podstron na podstawie makiety.'"
                :usedTech="'Głównie wykorzystane technologie:'"
                />
                <div class="tech-icons">
                  <TechIcon 
                    :tech="'https://i.imgur.com/Hxezg04.png'"
                  />
                  <TechIcon 
                    :tech="'https://i.imgur.com/0TZCvMJ.png'"
                  />
                  <TechIcon 
                    :tech="'https://i.imgur.com/Yg7MzAm.png'"
                  />
                </div>
                <p class="made-for">Wykonano dla: Sysmo</p>
          </div>
          </div>
          <div class="single-project hidden">
            <div class="img">
            <img src="https://i.imgur.com/OfHct0F.png" alt="">
            </div>
            <div class="info">
                <img src="https://i.imgur.com/Yz9Siqn.png" class="more-info" @click="moveToDziennik" alt="">
                <ProjectInfo 
                :title="'Dziennik Wędkarza'"
                :desc="'Bardzo prosty Landing Page bez żadnych podstron.'"
                :usedTech="'Głównie wykorzystane technologie:'"
                />
                <div class="tech-icons">
                  <TechIcon 
                    :tech="'https://i.imgur.com/Hxezg04.png'"
                  />
                  <TechIcon 
                    :tech="'https://i.imgur.com/0TZCvMJ.png'"
                  />
                  <TechIcon 
                    :tech="'https://i.imgur.com/IPGC8fZ.png'"
                  />
                </div>
                <p class="made-for">Wykonano dla: Sysmo</p>
            </div>
          </div>
          <div class="single-project hidden reverse">
           <div class="img">
            <img src="https://i.imgur.com/KYe3qS6.png" alt="">
            </div>
            <div class="info">
                <ProjectInfo 
                :title="'SkiInstruktor'"
                :desc="'Stworzenie strony głównej oraz kilku podstron z projektu graficznego.'"
                :usedTech="'Głównie wykorzystane technologie:'"
                />
                <div class="tech-icons">
                  <TechIcon 
                    :tech="'https://i.imgur.com/Hxezg04.png'"
                  />
                  <TechIcon 
                    :tech="'https://i.imgur.com/0TZCvMJ.png'"
                  />
                  <TechIcon 
                    :tech="'https://i.imgur.com/ibnrgcO.png'"
                  />
                </div>
                <p class="made-for">Wykonano dla: Sysmo</p>
            </div>
          </div>
          <div class="single-project hidden">
            <div class="img">
            <img src="https://i.imgur.com/ojoEWm1.png" alt="">
            </div>
            <div class="info">
                 <img src="https://i.imgur.com/Yz9Siqn.png" class="more-info" @click="moveToAutolivio" alt="">
                <ProjectInfo 
                :title="'Autolivio'"
                :desc="'Pierwszy większy samodzielny projekt (niekomercyjny)'"
                :usedTech="'Głównie wykorzystane technologie:'"
                />
                <div class="tech-icons">
                  <TechIcon 
                    :tech="'https://i.imgur.com/Hxezg04.png'"
                  />
                  <TechIcon 
                    :tech="'https://i.imgur.com/0TZCvMJ.png'"
                  />
                  <TechIcon 
                    :tech="'https://i.imgur.com/IPGC8fZ.png'"
                  />
                </div>
            </div>
          </div>
          <div class="single-project hidden reverse">
               <div class="img">
            <img src="https://i.imgur.com/NTIdEMn.png" alt="">
            </div>
            <div class="info">
                 <img src="https://i.imgur.com/Yz9Siqn.png" class="more-info" @click="moveToProdeck" alt="">
                 <ProjectInfo 
                :title="'ProDeck'"
                :desc="'Projekt tworzony na podstawie makiety graficznej.'"
                :usedTech="'Głównie wykorzystane technologie:'"
                />
                <div class="tech-icons">
                  <TechIcon 
                    :tech="'https://i.imgur.com/Hxezg04.png'"
                  />
                  <TechIcon 
                    :tech="'https://i.imgur.com/0TZCvMJ.png'"
                  />
                </div>
                <p class="made-for">Wykonano dla: Sysmo</p>
            </div>
          </div>
      </div>
  </section>
</template>

<script>
import ProjectInfo from '@/components/ProjectInfo.vue'
import TechIcon from '@/components/TechIcon.vue'
export default {
  name: "Portfolio",
  components: {
    ProjectInfo,
    TechIcon,
  },
  data() {
    return {
      tablet: false,
      mobile: false,
      windowWidth: null,
    };
  },
beforeMount() {
      window.addEventListener('resize', this.checkScreen);
      this.checkScreen();
    },

  methods: {
    checkScreen() {
      this.windowWidth = window.innerWidth;
        if (this.windowWidth <= 430) {
        this.mobile = true;
        this.tablet = false;
        return;
      }
       if(this.windowWidth <= 1024) {
        this.tablet = true;
        this.mobile = false;
        return;
      } 
    },
    
    moveToPogrzeby() {
        this.$router.push({ path: '/pogrzeby' });
    },
     moveToDaga() {
        this.$router.push({ path: '/daga' });
    },
     moveToAutolivio() {
        this.$router.push({ path: '/autolivio' });
    },
     moveToProdeck() {
        this.$router.push({ path: '/prodeck' });
    },
    moveToDziennik() {
        this.$router.push({ path: '/dziennik' });
    },

    
  },
  mounted() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
            entry.target.classList.add('show');
        }
      })
    });

    const hiddenElements = document.querySelectorAll('.hidden');
    hiddenElements.forEach((el) => observer.observe(el));
  }
};
</script>

<style lang="scss" scoped>

section.portfolio {
  background-color: #181621;
  padding: 4rem 0 5rem;
  overflow-x: hidden; 
  position: relative;
}

.title-container, .usage {
  color: #fff;
}

.usage {
  text-align: right;
  margin: 0 6rem 0 0;
}


.usage p {
  display: flex;
  justify-content: right;
  align-items: center;
  font-family: 'Poppins', sans-serif;
  font-size: 0.9rem;
@media(max-width: 425px) {
    flex-wrap: wrap;
}
}

.usage p img {
  margin: 0 0.2rem 0.3rem 0.2rem
}

.projects-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  .hidden {
    opacity: 0;
    filter: blur(5px);
    transform: translateX(-100%);
    transition: all 1.5s;
    @media(prefers-reduced-motion) {
      transition: none;
    }
  }

  .show {
    opacity: 1;
    transform: translateX(0);
    filter: blur(0);
  }

  .hidden.reverse {
    transform: translateX(100%);
    opacity: 0;
    filter: blur(5px);
    transition: all 1.5s;
  }

  .show.reverse {
    opacity: 1;
    transform: translateX(0);
    filter: blur(0);
  }

  .single-project {
    width: 30%;
    margin: 1rem;
    position: relative;
    z-index: 5;
    display: flex;
    align-items: center;
    justify-content: center;
    @media (max-width: 1024px) {
      width: 42%;
    }

    @media (max-width: 768px) {
      width: 44%;
    }

    @media (max-width: 425px) {
      width: 85%;
    }

    @media (max-width: 395px) {
      width: 88%;
      margin: 0.5rem;
    }

    @media (max-width: 350px) {
      width: 92%;
    }
  }
  .single-project:hover .info {
  display: block;
}

// box-shadow
// inset -2px -2px 4px hsla(0,0%,100%,.1),inset 2px 2px 4px rgba(0,0,0,.5);

    // .single-project-content {
    //   // min-height: 300px;
    //     display: flex;
    //     align-items: center;
    //     justify-content: center;

      .img {
        display: flex;
        align-items: center;
         img {
      width: 100%;
      // background-size: contain;
    }
      }
    // }
  
    .info {
      padding: 2.5rem 1rem;
      opacity: 0;
      color: #fff;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      bottom: 0;
      background-color: rgba(0,0,0, 0.75);
      transition: .3s; 
      // slide animation

      .more-info {
        position: absolute;
        bottom: 3%;
        right: 2%;
        width: 44px;
        cursor: pointer;
        @media(max-width: 768px) {
          width: 37px;
        }
         @media(max-width: 425px) {
          width: 39px;
        }
         @media(max-width: 375px) {
          width: 34px;
        }
      }

      .tech-icons {
        display: flex;
        margin-left: 2rem;
      }

      .made-for {
        position: absolute;
        bottom: 3%;
        left: 50%;
        transform: translateX(-50%)
      }
    }

    .single-project:hover .info {
    opacity: 1;

}

}


@media(max-width: 2250px) {
 .projects-container .info .made-for {
    font-size: 1.1rem;
  }
}

@media(max-width: 1024px) {
    .projects-container .info .made-for {
      bottom: 1%;
      font-size: 0.9rem;
    }

    section.portfolio {
    padding: 4rem 0 4.5rem;
}

}

@media(max-width: 768px) {
  .projects-container .info {
    padding: 1.6rem 0.6rem 0rem 0.2rem;
  }

  .projects-container .info .made-for {
      font-size: 0.85rem;
    }
    
  .usage {
    margin: 0;
  }

  .usage p {
  justify-content: center;
}
}

@media (max-width: 425px) {
  section.portfolio {
  padding: 3rem 0 2.5rem;
}
}

@media(max-width: 395px) {
  section.portfolio {
  padding: 2rem 0 1.5rem;
}

.title-container {
  padding: 0 0 0.3rem 0;
}

.projects-container .info .made-for {
    bottom: 0.8%;
  }

}

@media(max-width: 350px) {

  .projects-container .info {
    padding-top: 1rem;
  }

  .projects-container .info .tech-icons {
    margin-left: 1.5rem;
  }

  .projects-container .info .made-for {
    margin: 0;
    bottom: 0.4%;
  }
}




</style>